import styled from "styled-components"
import { colors } from "../../Utils/color"
import { Link, useNavigate } from "react-router-dom"
import { useEffect, useRef, useState } from "react"
import { SearchPopupDiv } from "../../Utils/style"
import { slugify } from "../MoviesSlider"

const HeaderDiv = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 100%;
    max-height: 45px;
    background-color: ${colors.secondary};
    padding: 15px 25px;
    z-index: 1000;
    border-bottom: 5px solid ${colors.primary};

    /* Petits écrans / mobiles larges */
    @media screen and (min-width: 480px) {
        //padding: 10px 20px;
    }

    /* Tablettes portrait */
    @media screen and (min-width: 768px) {
        padding: 10px 30px;
        gap: 20px;
    }

    /* Tablettes landscape + petits laptops */
    @media screen and (min-width: 1024px) {
        padding: 10px 10px 10px 20px;
        gap: 20px;
    }

    /* Desktop standard */
    @media screen and (min-width: 1200px) {
        padding: 10px 30px;
        gap: 40px;
    }

    > .fa-bars {
        display: block;
        font-size: 1.3rem;
        /* Tablettes portrait */
        @media screen and (min-width: 768px) {
            display: none;
        }
    }

    > .link {
        display: none;

        /* Tablettes portrait */
        @media screen and (min-width: 768px) {
            display: block;
        }
    }

    > .fsDiv {
        position: absolute;
        top: 65px;
        left: 0;
        right: 0;
        //display: flex;
        justify-content: space-between;
        max-width: 100%;
        max-height: 35px;
        background-color: ${colors.secondary};
        padding: 10px 20px 10px 20px;
    }

    > .logoDiv {
        width: fit-content;
        flex: none;

        /* Tablettes portrait */
        @media screen and (min-width: 768px) {
            flex: 1 1 100%;
            //width: auto;
        }
    }
`
const LogoLink = styled(Link)`
    font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
    width: fit-content;
    color: ${colors.primary};
    font-size: 2rem;
    font-weight: 600;
    text-decoration: none;

    > img {
        margin-top: 10px;
    }
`
const SearchDiv = styled.div`
    position: relative;
    flex: 0;
    display: flex;
    align-items: center;
    font-weight: 500;
    gap: 15px;
    background-color: rgba(71, 77, 92, 0.4);
    padding: 7px 12px;
    border-radius: 7px;

    /* Tablettes portrait */
    @media screen and (min-width: 768px) {
        flex: 1 1 100%;
    }

    > input {
        flex: 1 1 100%;
        font-size: 1rem;
        font-weight: 500;
        letter-spacing: -0.3px;
        color: rgba(255, 255, 255, 0.95);
        background: none;
        border: none;
        padding: 5px 0 4px 0;

        /* Tablettes portrait */
        @media screen and (min-width: 768px) {
            font-size: 1.05rem;
            padding: 6px 0 5px 0;
        }

        &:focus {
            outline: none;
        }
    }

    .fa-solid {
        font-size: 0.9rem;
        color: rgba(255, 255, 255, 0.95);

        /* Tablettes portrait */
        @media screen and (min-width: 1024px) {
            font-size: 0.93rem;
        }
    }
`
export const FSLink = styled(Link)`
    display: flex;
    flex: 1 1 50%;
    align-items: center;
    color: rgba(255, 255, 255, 0.95);
    font-size: 1rem;
    &:hover {
        color: ${colors.primary};
    }

    /* Tablettes portrait */
    @media screen and (min-width: 768px) {
        text-decoration: none;
        font-size: 1rem;
        font-weight: 600;
    }

    > span {
        @media screen and (min-width: 768px) and (max-width: 1024px) {
            display: none;
        }
    }

    > .fa-solid {
        margin-top: 5px;
        margin-right: 5px;
    }
`

function Header() {
    const [showMenu, setShowMenu] = useState(false)
    const [query, setQuery] = useState("")
    const [results, setResults] = useState([])
    const [showSearch, setShowSearch] = useState(false)
    const wrapperRef = useRef(null)

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (!query.trim()) {
                setResults([])
                return
            }

            fetch(`/api/search?q=${encodeURIComponent(query)}`)
                .then((res) => res.json())
                .then((data) => setResults(data.results))
                .catch((err) => console.error(err))
        }, 300)

        //return () => clearTimeout(timeoutId)

        function handleClickOutside(event) {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target)
            ) {
                setShowSearch(false) // ferme seulement si clic en dehors
            }
        }

        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            clearTimeout(timeoutId)
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [query])

    const navigate = useNavigate()
    const movieHandleClick = (id, titre, source) => {
        const urlTitle = slugify(titre)

        if (source === "Films") {
            navigate(`/film/${urlTitle}?film_id=${id}`)
        } else if (source === "Series") {
            navigate(`/serie/${urlTitle}?serie_id=${id}`)
        }

        setQuery("")
    }

    const AllSearchHandleClick = () => {
        navigate(`/rechercher?q=${query}`, {
            state: { results: results },
        })
        setQuery("")
    }

    return (
        <HeaderDiv>
            <div className="logoDiv">
                <LogoLink to="/">
                    <img src="/logo-sfr.webp" alt="logo" />
                    {/*SF<span>r</span>*/}
                </LogoLink>
            </div>
            <SearchDiv>
                <label for="searchMovie">
                    <i className="fa-solid fa-magnifying-glass"></i>
                </label>
                <input
                    type="text"
                    id="searchMovie"
                    name="searchMovie"
                    placeholder="Rechercher"
                    value={query}
                    onFocus={() => setShowSearch(true)}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <i
                    class="fa-solid fa-xmark"
                    style={{ display: query ? "initial" : "none" }}
                    onClick={() => setQuery("")}
                ></i>

                <SearchPopupDiv
                    ref={wrapperRef}
                    style={{ display: showSearch && query ? "flex" : "none" }}
                >
                    {results
                        .slice(0, 7)
                        .map(
                            ({
                                id,
                                titre,
                                cover,
                                date,
                                realisateurs,
                                source,
                            }) => (
                                <div
                                    className="resultsMovie"
                                    id="resultsMovie"
                                    key={`${source}-${id}`}
                                    onClick={() =>
                                        movieHandleClick(id, titre, source)
                                    }
                                >
                                    <img src={cover} alt="" />
                                    <div>
                                        <h2>{titre}</h2>
                                        <p>
                                            {source} de {realisateurs} <br />
                                            {date.slice(0, 4)}
                                        </p>
                                    </div>
                                </div>
                            ),
                        )}
                    <button onClick={AllSearchHandleClick}>
                        Tous les resultats pour "{query}"
                    </button>
                </SearchPopupDiv>
            </SearchDiv>

            <FSLink className="link" to="/films?page=1">
                <i class="fa-solid fa-film"></i>
                Films <span>Streaming</span>
            </FSLink>

            <FSLink className="link" to="/series?page=1">
                <i class="fa-solid fa-tv"></i>
                Séries TV <span>Streaming</span>
            </FSLink>

            <i
                class="fa-solid fa-bars"
                onClick={() => setShowMenu(!showMenu)}
            ></i>

            <div
                className="fsDiv"
                showMenu={showMenu}
                setShowMenu={setShowMenu}
                style={{ display: showMenu ? "flex" : "none" }}
            >
                <FSLink to="/films?page=1">
                    <i class="fa-solid fa-film"></i>
                    Films Streaming
                </FSLink>

                <FSLink to="/series?page=1">
                    <i class="fa-solid fa-tv"></i>
                    Séries TV Streaming
                </FSLink>
            </div>
        </HeaderDiv>
    )
}

export default Header
